/** @file Sets a slot's blend mode (normal, additive, multiply, screen). */
import { prim } from '@pose2d/format/doc/schemaParts/primitives';
import { defineCommand } from '../defineCommand';
import { defineSetter } from '../_shared/defineSetter';

const blendSetter = defineSetter({ domain: 'slot', kind: 'slot', field: 'blend', schema: prim.blend, description: 'Set a slot blend mode: normal, additive, multiply or screen.' });

/** slot.setBlend: the setter factory names it from the field; only a different mode is written (R2-13). */
export const command = defineCommand({
  ...blendSetter,
  apply(draft, input, ctx) {
    const slot = draft.slots[ctx.resolve('slot', input.target)];
    if (slot?.blend !== input.value) blendSetter.apply(draft, input, ctx);
  },
});
